import { useTranslation } from 'react-i18next';

const benefits = [
  { icon: 'ri-flashlight-line', key: 'feature1' },
  { icon: 'ri-shield-check-line', key: 'feature2' },
  { icon: 'ri-time-line', key: 'feature3' },
];

export default function Benefits() {
  const { t } = useTranslation();
  return (
    <section className="bg-bg border-t border-border">
      <div className="mx-auto max-w-5xl px-5 py-14 md:py-18">
        <div className="text-center mb-8">
          <h2 className="text-[24px] md:text-[28px] font-bold tracking-tight">{t('whyUs.section.title')}</h2>
          <p className="mt-2 text-[15px] text-muted">
            {t('whyUs.section.subtitle')}
          </p>
        </div>
        <ul className="grid gap-5 md:grid-cols-3">
          {benefits.map((b) => (
            <li
              key={b.key}
              className="flex flex-col items-center text-center rounded-xl border border-border bg-surface p-6"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary-soft text-primary">
                <i className={`${b.icon} text-[22px]`} />
              </div>
              <div className="mb-1 text-[16px] font-semibold text-ink">{t(`whyUs.${b.key}.title`)}</div>
              <div className="text-[14px] leading-[1.55] text-muted">{t(`whyUs.${b.key}.description`)}</div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
